import PropTypes from 'prop-types';
import React from 'react';
import {observer} from 'mobx-react';

import Icon from 'core/components/Icon.js';
import {Tooltip, Icon as IconHcl} from '@HealthShareAU/hs-component-library';

/**
 * Should only be displayed inside an integrated client (bp, zm, md, etc.)
 */
const BASE_CLASS = 'integrated-availability-callout';

export default
@observer
class IntegratedAvailabilityCallout extends React.Component {
    static propTypes = {
        formattedDate: PropTypes.string.isRequired,
        gaObjectType: PropTypes.string,
        gaSelector: PropTypes.string,
        newPatientsOnly: PropTypes.bool,
    };

    static defaultProps = {
        newPatientsOnly: false,
    };

    render() {
        const tooltipContent = (
            <p>
                {
                    'Availability for existing patients and urgent referrals may differ. Please call the practice for details.'
                }
            </p>
        );

        const newPatient = this.props.newPatientsOnly
            ? 'New patient next available'
            : 'Next available';

        return (
            <div
                className={BASE_CLASS}
                data-ga-object-type={this.props.gaObjectType}
                data-ga-selector={this.props.gaSelector}
            >
                <span className={`${BASE_CLASS}__svg-container`}>
                    <Icon name="availability" />{' '}
                </span>
                <span>{`${newPatient}: ${this.props.formattedDate}`}</span>
                <Tooltip text={tooltipContent}>
                    <span className={`${BASE_CLASS}__svg-container`}>
                        <IconHcl
                            name="info"
                            size="small"
                            customClass="next-available-tooltip"
                        />
                    </span>
                </Tooltip>
            </div>
        );
    }
}
